import { render, staticRenderFns } from "./oneMenu.vue?vue&type=template&id=23fd1b1c&scoped=true&"
import script from "./oneMenu.vue?vue&type=script&lang=js&"
export * from "./oneMenu.vue?vue&type=script&lang=js&"
import style0 from "./oneMenu.vue?vue&type=style&index=0&id=23fd1b1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fd1b1c",
  null
  
)

export default component.exports